export const packetsFromClientToServer = [
  {
    id: 180,
    path: [
      "77.75.79.138",
      "147.32.3.202",
      "217.31.205.50",
      "82.208.6.9",
      "57.200.0.1",
      "208.67.222.222",
      "2002:c0a8:101::1",
      "195.113.76.22",
    ],
    content: "",
    from: "77.75.79.138",
    to: "195.113.76.22",
    speed: 40,
  },
  {
    id: 181,
    path: [
      "77.75.79.138",
      "147.32.3.202",
      "91.198.174.192",
      "82.208.6.9",
      "208.67.222.222",
      "222.173.190.239",
      "2002:c0a8:101::1",
      "195.113.76.22",
    ],
    content: "",
    from: "77.75.79.138",
    to: "195.113.76.22",
    speed: 40,
  },
  {
    id: 182,
    path: [
      "77.75.79.138",
      "147.32.3.202",
      "217.31.205.50",
      "193.85.9.76",
      "82.208.6.9",
      "57.200.0.1",
      "2002:c0a8:101::1",
      "195.113.76.22",
    ],
    content: "",
    from: "77.75.79.138",
    to: "195.113.76.22",
    speed: 40,
  },
];
